<template>
  <div @click="outsideClick" class="risks-box">
    <div class="responsive-button">
      <span @click.prevent="close()"><font-awesome-icon style="margin-right: 10px;" :icon="['fa', 'arrow-left']"/> Voltar para Avatar</span>
    </div>
    <template v-if="diagnostics && diagnostics.length > 0">
      <div class="box-title">Diagnósticos Preliminares</div>
      <div class="risks-grid diagnostics" >
        <template v-for="diagnostic in diagnostics">
          <div v-bind:key="diagnostic.name" class="risk-card diagnostic" @click="$emit('openRisk', true, diagnostic.name, diagnostic.code, diagnostic)" >
            <div class="left">
              <div class="risk-icon">
                <img :src="require(`@/assets/images/risks/${getRiskIcon(diagnostic.label)}.png`)" />
              </div>
              <span class="risk-title">
                {{diagnostic.name}} - <span class="risk-label">{{diagnostic.label}}</span> 
              </span>
            </div>
            <span class="plus-icon">
              <font-awesome-icon class='btn-svg' :icon="['fa', 'plus-circle']" />
            </span>
          </div>
        </template>
      </div>
    </template>
    <template v-if="risks && risks.length > 0">
      <div class="box-title">Riscos</div>
      <div class="risks-grid" >
        <template v-for="risk in risks">
          <div v-bind:key="risk.name" class="risk-card" @click="$emit('openRisk', true, risk.title, risk.altTitle, risk)" >
            <div class="left">
              <div class="risk-icon">
                <img :src="require(`@/assets/images/risks/${getRiskIcon(risk.label)}.png`)" />
              </div>
              <span class="risk-title">
                {{risk.name}} - <span class="risk-label">{{risk.label}}</span>
              </span>
            </div>
            <span class="plus-icon">
              <font-awesome-icon class='btn-svg' :icon="['fa', 'plus-circle']" />
            </span>
          </div>
        </template>
      </div>
    </template>
    <template v-if="factors && factors.length > 0">
      <div class="box-title">Fatores Preliminares</div>
      <div class="risks-grid factors">
        <template v-for="factor in factors">
          <div v-bind:key="factor.name" class="risk-card" @click="$emit('openRisk', true, factor.title, factor.altTitle, factor)" >
            <div class="left">
              <div class="risk-icon">
                <img :src="require(`@/assets/images/risks/${getRiskIcon(factor.label)}.png`)" />
              </div>
              <span class="risk-title">
                {{factor.name}} - <span class="risk-label">{{factor.label}}</span>
              </span>
            </div>
            <span class="plus-icon">
              <font-awesome-icon class='btn-svg' :icon="['fa', 'plus-circle']" />
            </span>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core';
import {faCircle, faMinusCircle, faInfoCircle, faReceipt} from '@fortawesome/free-solid-svg-icons';

export default {
  name: "risks-card",
  components: { },
  props: {
    diagnostics: Array,
    risks: Array,
    factors: Array,
  },
  data() {
    return {
      
    }
  },
  methods: {
    getRiskIcon(label) {
      switch(label) {
        case 'Não detectado': return 'b_g';
        case 'Baixo': return 'b_g';
        case 'Médio baixo': return 'b_g';
        case 'Médio': return 'b_y';
        case 'Médio alto': return 'b_y';
        case 'Alto': return 'b_r';
        case 'Detectado': return 'b_r';
        default: return 'b_g';
      }
    },
    close() {
      this.$emit('close');
    },
    outsideClick() {
      let mobile = window.screen.width <= 910;
      if(mobile && event.target === event.currentTarget)
          this.$emit('close');
    }
  },
  mounted() {
    console.log('>>', this.factors)
  }
}
</script>

<style>
    @import "./risks-card.scss";
    @import "./responsive.css";
</style>


// WEBPACK FOOTER //
// src/components/RisksCard/RisksCard.vue